import * as THREE from "../../libs/three.js/build/three.module.js";



THREE.WebGLRenderer.prototype.paramThreeToGL = function(e) {
    var t, i = this.extensions, r = this.getContext();//context;
    if (e === THREE.RepeatWrapping)
        return r.REPEAT;
    if (e === THREE.ClampToEdgeWrapping)
        return r.CLAMP_TO_EDGE;
    if (e === THREE.MirroredRepeatWrapping)
        return r.MIRRORED_REPEAT;
    if (e === THREE.NearestFilter)
        return r.NEAREST;
    if (e === THREE.NearestMipMapNearestFilter)
        return r.NEAREST_MIPMAP_NEAREST;
    if (e === THREE.NearestMipMapLinearFilter)
        return r.NEAREST_MIPMAP_LINEAR;
    if (e === THREE.LinearFilter)
        return r.LINEAR;
    if (e === THREE.LinearMipMapNearestFilter)
        return r.LINEAR_MIPMAP_NEAREST;
    if (e === THREE.LinearMipMapLinearFilter)
        return r.LINEAR_MIPMAP_LINEAR;
    if (e === THREE.UnsignedByteType)
        return r.UNSIGNED_BYTE;
    if (e === THREE.UnsignedShort4444Type)
        return r.UNSIGNED_SHORT_4_4_4_4;
    if (e === THREE.UnsignedShort5551Type)
        return r.UNSIGNED_SHORT_5_5_5_1;
    if (e === THREE.UnsignedShort565Type)
        return r.UNSIGNED_SHORT_5_6_5;
    if (e === THREE.ByteType)
        return r.BYTE;
    if (e === THREE.ShortType)
        return r.SHORT;
    if (e === THREE.UnsignedShortType)
        return r.UNSIGNED_SHORT;
    if (e === THREE.IntType)
        return r.INT;
    if (e === THREE.UnsignedIntType)
        return r.UNSIGNED_INT;
    if (e === THREE.FloatType)
        return r.FLOAT;
    if (t = i.get("OES_texture_half_float"),
    null !== t && e === THREE.HalfFloatType)
        return t.HALF_FLOAT_OES;
    if (e === THREE.AlphaFormat)
        return r.ALPHA;
    if (e === THREE.RGBFormat)
        return r.RGB;
    if (e === THREE.RGBAFormat)
        return r.RGBA;
    if (e === THREE.LuminanceFormat)
        return r.LUMINANCE;
    if (e === THREE.LuminanceAlphaFormat)
        return r.LUMINANCE_ALPHA;
    if (e === THREE.AddEquation)
        return r.FUNC_ADD;
    if (e === THREE.SubtractEquation)
        return r.FUNC_SUBTRACT;
    if (e === THREE.ReverseSubtractEquation)
        return r.FUNC_REVERSE_SUBTRACT;
    if (e === THREE.ZeroFactor)
        return r.ZERO;
    if (e === THREE.OneFactor)
        return r.ONE;
    if (e === THREE.SrcColorFactor)
        return r.SRC_COLOR;
    if (e === THREE.OneMinusSrcColorFactor)
        return r.ONE_MINUS_SRC_COLOR;
    if (e === THREE.SrcAlphaFactor)
        return r.SRC_ALPHA;
    if (e === THREE.OneMinusSrcAlphaFactor)
        return r.ONE_MINUS_SRC_ALPHA;
    if (e === THREE.DstAlphaFactor)
        return r.DST_ALPHA;
    if (e === THREE.OneMinusDstAlphaFactor)
        return r.ONE_MINUS_DST_ALPHA;
    if (e === THREE.DstColorFactor)
        return r.DST_COLOR;
    if (e === THREE.OneMinusDstColorFactor)
        return r.ONE_MINUS_DST_COLOR;
    if (e === THREE.SrcAlphaSaturateFactor)
        return r.SRC_ALPHA_SATURATE;
    if (t = i.get("WEBGL_compressed_texture_s3tc"),
    null !== t) {
        if (e === THREE.RGB_S3TC_DXT1_Format)
            return t.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (e === THREE.RGBA_S3TC_DXT1_Format)
            return t.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (e === THREE.RGBA_S3TC_DXT3_Format)
            return t.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (e === THREE.RGBA_S3TC_DXT5_Format)
            return t.COMPRESSED_RGBA_S3TC_DXT5_EXT
    }
    if (t = i.get("WEBGL_compressed_texture_pvrtc"),
    null !== t) {
        if (e === THREE.RGB_PVRTC_4BPPV1_Format)
            return t.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (e === THREE.RGB_PVRTC_2BPPV1_Format)
            return t.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (e === THREE.RGBA_PVRTC_4BPPV1_Format)
            return t.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (e === THREE.RGBA_PVRTC_2BPPV1_Format)
            return t.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
    }
    if (t = i.get("WEBGL_compressed_texture_etc1"),
    null !== t && e === THREE.RGB_ETC1_Format)
        return t.COMPRESSED_RGB_ETC1_WEBGL;
    if (t = i.get("EXT_blend_minmax"),
    null !== t) {
        if (e === THREE.MinEquation)
            return t.MIN_EXT;
        if (e === THREE.MaxEquation)
            return t.MAX_EXT
    }
    return 0
}
 

THREE.EventDispatcher.prototype.addEventListener = function(type, listener, {importance=0, once}={}){    //add importance
	if ( this._listeners === undefined ) this._listeners = {};

		const listeners = this._listeners;

		if ( listeners[ type ] === undefined ) { 
			listeners[ type ] = []; 
		}
        /* if(type == 'flyingDone'){
            console.log('addEventListener flyingDone')
        } */
		if ( !listeners[ type ].some(e=>e.listener == listener )  ) {  
            listeners[type].push({ listener, importance, once});
            listeners[type] = listeners[type].sort((e,a)=> a.importance - e.importance)//add
		} 
}

THREE.EventDispatcher.prototype.hasEventListener = function(type, listener){
	if ( this._listeners === undefined ) return false;

	const listeners = this._listeners;

	return listeners[ type ] !== undefined &&  listeners[ type ].some(e=>e.listener == listener )  
}

THREE.EventDispatcher.prototype.removeEventListener = function(type, listener){
	if ( this._listeners === undefined ) return;

	const listeners = this._listeners;
	const listenerArray = listeners[ type ];

	if ( listenerArray !== undefined ) {

		/* const index = listenerArray.indexOf( listener );

		if ( index !== - 1 ) {

			listenerArray.splice( index, 1 );

		} */

		let item = listenerArray.find(e=>e.listener == listener)
		item && listenerArray.splice(listenerArray.indexOf(item), 1);

	}
}

THREE.EventDispatcher.prototype.removeEventListeners = function(type){  //add
	if(this._listeners && this._listeners[type] !== undefined){
		delete this._listeners[type];
	}
}

THREE.EventDispatcher.prototype.removeAllListeners = function(){  //add
	this._listeners = {};
}

THREE.EventDispatcher.prototype.dispatchEvent = function(event){ 
	if(typeof event == 'string'){//add
        event = {type:event}
    }
    if ( this._listeners === undefined ) return;

    const listeners = this._listeners;
    const listenerArray = listeners[ event.type ];

    if ( listenerArray !== undefined ) {

        event.target = this;

        // Make a copy, in case listeners are removed while iterating. 
        for(let {listener, once} of listenerArray.slice(0)){
            if(once){
                this.removeEventListener(event.type,listener)
            }
            let result = listener.call(this, event);   //add stopContinue
            
            if(result && result.stopContinue){
                break
            }
        }

    }
} 

THREE.EventDispatcher.prototype.traverse = function(callback){ 
    let result = callback( this );
    if(result && result.stopContinue){//xzw add
        return 
    }
         
    const children = this.children;
    if(children){
        for ( let i = 0, l = children.length; i < l; i ++ ) {

            children[ i ].traverse( callback );

        }
    }
}

THREE.Quaternion.prototype.toObject = function(e){
    return {
        x: this.x, y:this.y, z:this.z, w:this.w
    }
}
THREE.Euler.prototype.toObject = function(addOrder){
    let euler = {
        x: this.x, y:this.y, z:this.z
    }
    addOrder && (euler.order = this.order)
    return euler
}

THREE.Object3D.prototype.traverse = function ( callback, lastResult ) {

    let result = callback( this, lastResult ); //lastResult一般用于收集祖先的visible
    if(result && result.stopContinue){//xzw add
        return 
    }
         
    const children = this.children;

    for ( let i = 0, l = children.length; i < l; i ++ ) {  
        children[ i ] && children[ i ].traverse( callback, result ); 
    } 
}   

THREE.Shim.FollowRootObject = function(root){
    THREE.Object3D.call(this)
    this.root = root
}  
 
THREE.Shim.FollowRootObject.prototype  = Object.assign( Object.create(THREE.Object3D.prototype), {  
    constructor: THREE.Shim.FollowRootObject,     
  
    updateMatrixWorld(force){ //重写，只为了将root当做parent
 
        this.scale.set(1/this.root.scale.x, 1/this.root.scale.y, 1/this.root.scale.z ) //中和模型缩放。无论模型缩放如何都不能改tag大小
  
        this.updateMatrix() 
        this.matrixWorld.multiplyMatrices( this.root.matrixWorld ,   this.matrix );
         
        const children = this.children;
        for ( let i = 0, l = children.length; i < l; i ++ ) {
            children[ i ].updateMatrixWorld( force );
        }  
    },

    
    updateWorldMatrix( updateParents, updateChildren ) {//重写，只为了将root当做parent
 
        if ( updateParents === true && this.root !== null ) {
            this.root.updateWorldMatrix( true, false );
        }

        if ( this.matrixAutoUpdate ) this.updateMatrix();
        this.matrixWorld.multiplyMatrices( this.root.matrixWorld, this.matrix );

        if ( updateChildren === true ) {
            const children = this.children;
            for ( let i = 0, l = children.length; i < l; i ++ ) {
                children[ i ].updateWorldMatrix( false, true );
            }
        }

    }  
}) 

        
        
        
       

    
        
        
        
        
        
        
        
        
        
        
        
        

THREE.Material.prototype.setValues = function ( values ) {

    if ( values === undefined ) return;

    for ( const key in values ) {

        const newValue = values[ key ];

        if ( newValue === undefined ) {

            console.warn( 'THREE.Material: \'' + key + '\' parameter is undefined.' );
            continue;

        }

        // for backward compatability if shading is set in the constructor
        if ( key === 'shading' ) {

            console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
            this.flatShading = ( newValue === FlatShading ) ? true : false;
            continue;

        }

        const currentValue = this[ key ]; 

        /* if ( currentValue === undefined ) { //-----主要删了这段，否则很难和 set 一起使用

            //console.warn( 'THREE.' + this.type + ': \'' + key + '\' is not a property of this material.' );
            continue; 
        } */

        if ( currentValue && currentValue.isColor ) {

            currentValue.set( newValue );

        } else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

            currentValue.copy( newValue );

        } else {

            this[ key ] = newValue;

        }

    }

} 

function ascSort( a, b ) {

	return a.distance - b.distance;

}


function intersectObject( object, raycaster, intersects, recursive,  ignoreUnvisible ) {
    
    if(ignoreUnvisible && !object.visible)return  //add
    
	if ( object.layers.test( raycaster.layers ) ) {

		object.raycast( raycaster, intersects );

	}

	if ( recursive === true ) {

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			intersectObject( children[ i ], raycaster, intersects, true, ignoreUnvisible);

		}

	}

}

THREE.Raycaster.prototype.intersectObject = function ( object, recursive, optionalTarget, ignoreUnvisible ) {

    const intersects = optionalTarget || [];
 
    intersectObject( object, this, intersects, recursive, ignoreUnvisible );

    intersects.sort( ascSort );

    return intersects;

} 

THREE.Raycaster.prototype.intersectObjects = function ( objects, recursive, optionalTarget, ignoreUnvisible ) {//add ignoreUnvisible 跳过不可见

    const intersects = optionalTarget || [];

    if ( Array.isArray( objects ) === false ) {

        console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
        return intersects;

    }

    for ( let i = 0, l = objects.length; i < l; i ++ ) {

        intersectObject( objects[ i ], this, intersects, recursive, ignoreUnvisible );

    }

    intersects.sort( ascSort );

    return intersects;

}



THREE.Object3D.prototype.realVisible = function(){
    let v = true 
    let parent = this 
    let lastParent
    while(parent){
        if(parent.visible === false){
            v = false
            break; 
        }
        lastParent = parent
        parent = parent.parent
    }
     
    if(v && !(lastParent instanceof THREE.Scene)){//已被删除
        v = false
    }   
    return v                                
}
THREE.Object3D.prototype.isChildOf = function(rootParent ){//是否后代, 包括自身
    let parent = this 
    while(parent){
        if(parent == rootParent){
            return true
            break
        } 
        parent = parent.parent 
    }
}
THREE.Curve.prototype.getPointAt = function ( u, optionalTarget ) { 
    const t = this.getUtoTmapping( u );
    this.UtoTMapArr && this.UtoTMapArr.push(t) //add
    return this.getPoint( t, optionalTarget );

} 


const _inverseMatrix$3 = /*@__PURE__*/ new THREE.Matrix4();
const _ray$3 = /*@__PURE__*/ new THREE.Ray();
const _sphere$6 = /*@__PURE__*/ new THREE.Sphere();
const _sphereHitAt = /*@__PURE__*/ new THREE.Vector3();

const _vA$1 = /*@__PURE__*/ new THREE.Vector3();
const _vB$1 = /*@__PURE__*/ new THREE.Vector3();
const _vC$1 = /*@__PURE__*/ new THREE.Vector3();

const _tempA = /*@__PURE__*/ new THREE.Vector3();
const _morphA = /*@__PURE__*/ new THREE.Vector3();

const _intersectionPoint = /*@__PURE__*/ new THREE.Vector3();
const _intersectionPointWorld = /*@__PURE__*/ new THREE.Vector3();


const _basePosition = /*@__PURE__*/ new THREE.Vector3();

const _skinIndex = /*@__PURE__*/ new THREE.Vector4();
const _skinWeight = /*@__PURE__*/ new THREE.Vector4();

const _vector3 = /*@__PURE__*/ new THREE.Vector3();
const _matrix4 = /*@__PURE__*/ new THREE.Matrix4();
const _vertex = /*@__PURE__*/ new THREE.Vector3();
const _sphere$5 = /*@__PURE__*/ new THREE.Sphere();
const _inverseMatrix$2 = /*@__PURE__*/ new THREE.Matrix4();
const _ray$2 = /*@__PURE__*/ new THREE.Ray();




THREE.SkinnedMesh.prototype.computeBoundingSphere = function(){

    const geometry = this.geometry;

    if ( !this.boundingSphere ) {

        this.boundingSphere = new THREE.Sphere();

    }

    this.boundingSphere.makeEmpty();

    const positionAttribute = geometry.getAttribute( 'position' );

    for ( let i = 0; i < positionAttribute.count; i ++ ) {

        this.getVertexPosition( i, _vertex );
        this.boundingSphere.expandByPoint( _vertex );

    }

}
THREE.SkinnedMesh.prototype.computeBoundingBox = function(){

    const geometry = this.geometry;

    if ( !this.boundingBox  ) {

        this.boundingBox = new THREE.Box3();

    }

    this.boundingBox.makeEmpty();

    const positionAttribute = geometry.getAttribute( 'position' );

    for ( let i = 0; i < positionAttribute.count; i ++ ) {

        this.getVertexPosition( i, _vertex );
        this.boundingBox.expandByPoint( _vertex );

    }

}
THREE.SkinnedMesh.prototype.raycast = function( raycaster, intersects ) {//根据r173重写，因模型大小跟着骨骼走 
    const material = this.material;
    const matrixWorld = this.matrixWorld;

    if ( material === undefined ) return;

    // test with bounding sphere in world space

    if ( !this.boundingSphere ) this.computeBoundingSphere();

    _sphere$5.copy( this.boundingSphere );
    _sphere$5.applyMatrix4( matrixWorld );

    if ( raycaster.ray.intersectsSphere( _sphere$5 ) === false ) return;

    // convert ray to local space of skinned mesh

    _inverseMatrix$2.copy( matrixWorld ).invert();
    _ray$2.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$2 );

    // test with bounding box in local space

    if ( this.boundingBox ) {

        if ( _ray$2.intersectsBox( this.boundingBox ) === false ) return;

    }

    // test for intersections with geometry

    this._computeIntersections( raycaster, intersects, _ray$2 );
}

THREE.SkinnedMesh.prototype.getVertexPosition = function( index, target ) {

    //super.getVertexPosition( index, target );
    

    const geometry = this.geometry;
    const position = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;

    target.fromBufferAttribute( position, index );

    const morphInfluences = this.morphTargetInfluences;

    if ( morphPosition && morphInfluences ) {

        _morphA.set( 0, 0, 0 );

        for ( let i = 0, il = morphPosition.length; i < il; i ++ ) {

            const influence = morphInfluences[ i ];
            const morphAttribute = morphPosition[ i ];

            if ( influence === 0 ) continue;

            _tempA.fromBufferAttribute( morphAttribute, index );

            if ( morphTargetsRelative ) {

                _morphA.addScaledVector( _tempA, influence );

            } else {

                _morphA.addScaledVector( _tempA.sub( target ), influence );

            }

        }

        target.add( _morphA );

    }

    
    this.applyBoneTransform( index, target );

    return target;

}



THREE.SkinnedMesh.prototype.applyBoneTransform = function( index, vector ) {

    const skeleton = this.skeleton;
    const geometry = this.geometry;

    _skinIndex.fromBufferAttribute( geometry.attributes.skinIndex, index );
    _skinWeight.fromBufferAttribute( geometry.attributes.skinWeight, index );

    _basePosition.copy( vector ).applyMatrix4( this.bindMatrix );

    vector.set( 0, 0, 0 );

    for ( let i = 0; i < 4; i ++ ) {

        const weight = _skinWeight.getComponent( i );

        if ( weight !== 0 ) {

            const boneIndex = _skinIndex.getComponent( i );

            _matrix4.multiplyMatrices( skeleton.bones[ boneIndex ].matrixWorld, skeleton.boneInverses[ boneIndex ] );

            vector.addScaledVector( _vector3.copy( _basePosition ).applyMatrix4( _matrix4 ), weight );

        }

    }

    return vector.applyMatrix4( this.bindMatrixInverse );

}

 
THREE.SkinnedMesh.prototype._computeIntersections = function( raycaster, intersects, rayLocalSpace ) {

    let intersection;

    const geometry = this.geometry;
    const material = this.material;

    const index = geometry.index;
    const position = geometry.attributes.position;
    const uv = geometry.attributes.uv;
    const uv1 = geometry.attributes.uv1;
    const normal = geometry.attributes.normal;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;

    if ( index !== null ) {

        // indexed buffer geometry

        if ( Array.isArray( material ) ) {

            for ( let i = 0, il = groups.length; i < il; i ++ ) {

                const group = groups[ i ];
                const groupMaterial = material[ group.materialIndex ];

                const start = Math.max( group.start, drawRange.start );
                const end = Math.min( index.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

                for ( let j = start, jl = end; j < jl; j += 3 ) {

                    const a = index.getX( j );
                    const b = index.getX( j + 1 );
                    const c = index.getX( j + 2 );

                    intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

                    if ( intersection ) {

                        intersection.faceIndex = Math.floor( j / 3 ); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push( intersection );

                    }

                }

            }

        } else {

            const start = Math.max( 0, drawRange.start );
            const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

            for ( let i = start, il = end; i < il; i += 3 ) {

                const a = index.getX( i );
                const b = index.getX( i + 1 );
                const c = index.getX( i + 2 );

                intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

                if ( intersection ) {

                    intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indexed buffer semantics
                    intersects.push( intersection );

                }

            }

        }

    } else if ( position !== undefined ) {

        // non-indexed buffer geometry

        if ( Array.isArray( material ) ) {

            for ( let i = 0, il = groups.length; i < il; i ++ ) {

                const group = groups[ i ];
                const groupMaterial = material[ group.materialIndex ];

                const start = Math.max( group.start, drawRange.start );
                const end = Math.min( position.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

                for ( let j = start, jl = end; j < jl; j += 3 ) {

                    const a = j;
                    const b = j + 1;
                    const c = j + 2;

                    intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

                    if ( intersection ) {

                        intersection.faceIndex = Math.floor( j / 3 ); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push( intersection );

                    }

                }

            }

        } else {

            const start = Math.max( 0, drawRange.start );
            const end = Math.min( position.count, ( drawRange.start + drawRange.count ) );

            for ( let i = start, il = end; i < il; i += 3 ) {

                const a = i;
                const b = i + 1;
                const c = i + 2;

                intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

                if ( intersection ) {

                    intersection.faceIndex = Math.floor( i / 3 ); // triangle number in non-indexed buffer semantics
                    intersects.push( intersection );

                }

            }

        }

    }

}

const _v40 = /*@__PURE__*/ new THREE.Vector4();
const _v41 = /*@__PURE__*/ new THREE.Vector4();
const _v42 = /*@__PURE__*/ new THREE.Vector4();
function checkGeometryIntersection( object, material, raycaster, ray, uv, uv1, normal, a, b, c ) {

	object.getVertexPosition( a, _vA$1 );
	object.getVertexPosition( b, _vB$1 );
	object.getVertexPosition( c, _vC$1 );

	const intersection = checkIntersection$1( object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint );

	if ( intersection ) {

		const barycoord = new THREE.Vector3();
		THREE.Triangle.getBarycoord( _intersectionPoint, _vA$1, _vB$1, _vC$1, barycoord );

		if ( uv ) {

			intersection.uv = THREE.Triangle.getInterpolatedAttribute( uv, a, b, c, barycoord, new THREE.Vector2() );

		}

		if ( uv1 ) {

			intersection.uv1 = THREE.Triangle.getInterpolatedAttribute( uv1, a, b, c, barycoord, new THREE.Vector2() );

		}

		if ( normal ) {

			intersection.normal = THREE.Triangle.getInterpolatedAttribute( normal, a, b, c, barycoord, new THREE.Vector3() );

			if ( intersection.normal.dot( ray.direction ) > 0 ) {

				intersection.normal.multiplyScalar( - 1 );

			}

		}

		const face = {
			a: a,
			b: b,
			c: c,
			normal: new THREE.Vector3(),
			materialIndex: 0
		};

		THREE.Triangle.getNormal( _vA$1, _vB$1, _vC$1, face.normal );

		intersection.face = face;
		intersection.barycoord = barycoord;

	}

	return intersection;

}
function checkIntersection$1( object, material, raycaster, ray, pA, pB, pC, point ) {

	let intersect;

	if ( material.side === THREE.BackSide ) {

		intersect = ray.intersectTriangle( pC, pB, pA, true, point );

	} else {

		intersect = ray.intersectTriangle( pA, pB, pC, ( material.side === THREE.FrontSide ), point );

	}

	if ( intersect === null ) return null;

	_intersectionPointWorld.copy( point );
	_intersectionPointWorld.applyMatrix4( object.matrixWorld );

	const distance = raycaster.ray.origin.distanceTo( _intersectionPointWorld );

	if ( distance < raycaster.near || distance > raycaster.far ) return null;

	return {
		distance: distance,
		point: _intersectionPointWorld.clone(),
		object: object
	};

}
 
const _v1$6 = /*@__PURE__*/ new THREE.Vector3();
const _v2$3 = /*@__PURE__*/ new THREE.Vector3();
THREE.Sphere.prototype.expandByPoint = function( point ) {

    if ( this.isEmpty() ) {

        this.center.copy( point );

        this.radius = 0;

        return this;

    }

    _v1$6.subVectors( point, this.center );

    const lengthSq = _v1$6.lengthSq();

    if ( lengthSq > ( this.radius * this.radius ) ) {

        // calculate the minimal sphere

        const length = Math.sqrt( lengthSq );

        const delta = ( length - this.radius ) * 0.5;

        this.center.addScaledVector( _v1$6, delta / length );

        this.radius += delta;

    }

    return this;

}




/* THREE.Triangle.prototype.getBarycoord( point, target ) {

    return Triangle.getBarycoord( point, this.a, this.b, this.c, target );

} */

THREE.Triangle.getInterpolatedAttribute = function( attr, i1, i2, i3, barycoord, target ) {

    _v40.setScalar( 0 );
    _v41.setScalar( 0 );
    _v42.setScalar( 0 );

    _v40.fromBufferAttribute( attr, i1 );
    _v41.fromBufferAttribute( attr, i2 );
    _v42.fromBufferAttribute( attr, i3 );

    target.setScalar( 0 );
    target.addScaledVector( _v40, barycoord.x );
    target.addScaledVector( _v41, barycoord.y );
    target.addScaledVector( _v42, barycoord.z );

    return target;

}